import { render, staticRenderFns } from "./actForm.vue?vue&type=template&id=1754ef86&"
import script from "./actForm.vue?vue&type=script&lang=js&"
export * from "./actForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports